module.exports = __webpack_public_path__ + "static/assets/b37899820e422531010f4a23f218fd52.png";